module.exports = __webpack_public_path__ + "img/m2.2eb0910d.png";